import { render, staticRenderFns } from "./BenefitBertPoints.vue?vue&type=template&id=2179eaa2&scoped=true"
import script from "./BenefitBertPoints.vue?vue&type=script&lang=js"
export * from "./BenefitBertPoints.vue?vue&type=script&lang=js"
import style0 from "./BenefitBertPoints.vue?vue&type=style&index=0&id=2179eaa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2179eaa2",
  null
  
)

export default component.exports